export const ErrorMessages = {
  'MOS-1001': 'Invalid request',
  'MOS-1002': 'Mandatory header missing in request.',
  'MOS-1003': 'Invalid PAN number. Please retry with a valid PAN.',
  'MOS-1004': 'Please enter a valid Annual Revenue value.',
  'MOS-1005': 'No Merchant MCC details found for given Account ID.',
  'MOS-1006': 'No Merchant Account details found for given Account ID.',
  'MOS-1007': 'Invalid fields or requested fields are not allowed to be changed.',
  'MOS-1009': 'Invalid Account ID',
  'MOS-1010': 'Account MCC not found',
  'MOS-1011': 'Account MCC not found',
  'MOS-1012': 'Merchant Account not found',
  'MOS-1013': 'Merchant Contact not found',
  'MOS-1014': 'Account already exists with shared PAN',
  'MOS-1015': 'Please chose city corresponding to updated state',
  'MOS-2001': 'User not authorised',
  'MOS-2002': 'Due to security issue, please logout and login',
  'MOS-2003': 'User not authorised',
  'MOS-3001': 'Technical Error',
  'MOS-3002': 'Technical Error',
  'MOS-3003': 'Technical Error',
  'MOS-3004': 'Technical Error',
  'MOS-3005': 'Technical Error',
  'MOS-3006': 'Technical Error',
  'MPS-1001': 'Technical Error',
  'MPS-1002': 'Error occurred while verifying Bank Account. Please try again later.',
  'MPS-1003': 'Error occurred while verifying Bank Account. Please try again later.',
  'MPS-1004': 'Error occurred while verifying Bank Account. Please try again later.',
  'MPS-2001': 'Bank account details not found',
  'MPS-2003': 'This Bank is not yet supported. Please try with different Bank account.',
  'MPS-3001': 'User not authorised',
  'MPS-3002': 'User not authorised',
  'MPS-3003': 'Due to security issue, please logout and login',
  'MPS-3004': 'Technical Error',
  'MPS-3005': 'Technical Error',
  'MPS-3006': 'Technical Error',
  'MPS-3007': 'Technical Error',
  'MPS-3008':
    'This bank account is already linked with another merchant. Please try different details.',
  'BS-1001': 'Please select Valid City and State',
  'BS-1003': 'Error in creating Merchant Account',
  'BS-1005': 'Technical Error',
  'BS-1006': 'Invalid GST Number format',
  'MSS-1001': 'Store not found',
  'MSS-105': 'Technical Error',
  'MSS-106': 'Technical Error',
  'MSS-101': 'Technical Error',
  'MSS-1016': 'Please select correct city and state for Business',
  'MSS-1017': 'Please select correct city and state for Business',
  'ODS-101': 'Opportunity not found',
  'ODS-103': 'Opportunity not found',

  'ODS-104': 'Please fill all the fields to proceed',
  'ODS-105': 'Nach Amount is null',
  'ODS-109':
    'Please add products to continue. If you have already added products, please wait while we fetch products from Salesforce',
  'ODS-110':
    'Please add products to continue. If you have already added products, please wait while we fetch products from Salesforce',
  'ODS-401': 'User not authorised',
  'BS-1002': 'Billing Entity not found',
  'BS-1004': 'Please select Valid City and State',
  'BS-1007': 'GSTIN is Invalid',
  'BS-3001': 'Error in creating Merchant Account',
  'BS-3002': 'Error in creating Merchant Account',
  'BS-2001': 'User not authorised',
  'BS-2002': 'User access expired. Please login again to continue',
  'BS-2003': 'Technical Error',
  'BS-2004': 'Technical Error',
  'BS-2005': 'Technical Error',
  'DE-1009': 'GSTIN is Invalid',
  'DE-2006': 'Document not found',
  'DE-3002': 'GSTIN is Invalid',
  'DE-4001': 'Incorrect PAN',
  'LMS-101': 'Lead ID not found',
  'LMS-102': 'Technical Error',
  'LMS-103': 'Incorrect Data',
  'LMS-1050': 'Incorrect Data',
  'LMS-106': 'Technical Error',
  'ODS-113': 'Opportunity query code not found',
  'ODS-114': 'Bank account details not found',
  'ODS-115': 'Merchant Account not found',
  'DE-2011': 'Error in extracting document data',
  'DE-3017': 'Error in processing DigiLocker photo',
  'DE-2013': 'Error in processing DigiLocker photo',
  'DE-3018': 'Error in performing OCR',
  'DE-2014': 'Error in performing OCR',

  'MIS-1001': 'Mandatory header missing in request.',
  'MIS-1008': 'Error occurred while processing request. Please reach out to technical team',
}

export const MandateCreationFailedCodes = [
  'ODS-118',
  'ODS-124',
  'NOT_ENACH_ESIGN_ELIGIBLE',
  'NOT_ENACH_ELIGIBLE',
]
